const _ = require('lodash');
const Providers = require('./providers');
const GlobalProperties = require('./global_properties_attached_to_events');

function invokeAll(method, ...args) {
    for (const providerName in Providers) {
        const provider = Providers[providerName];
        if (_.isFunction(provider && provider[method])) {
            // check if function exists before call
            try {
                provider[method](...args);
            } catch (_err) {
                // intentionally ignored
            }
        }
    }
}

function startSession(profile, options = {}) {
    invokeAll('startSession', profile, options);
}

function startGtmSession(profile, options = {}) {
    const provider = Providers.GoogleTagManager;
    if (provider && _.isFunction(provider.startSession)) {
        try {
            provider.startSession(profile, options);
        } catch (_err) {
            // intentionally ignored
        }
    }
}

function endSession(profile) {
    invokeAll('endSession', profile);
}

function trackEvent(event, metadata) {
    invokeAll('trackEvent', event, Object.assign({}, metadata, GlobalProperties.items()));
}

function registerSuperProperties(properties) {
    invokeAll('register', properties);
}

module.exports = {
    startSession, // enabling interaction with intercom (chat, analytics) in localhost
    startGtmSession,
    endSession, // enabling interaction with intercom (chat, analytics) in localhost
    trackEvent, // enabling interaction with intercom (chat, analytics) in localhost
    registerSuperProperties,
    // startSession: (Config.localhost ? (() => { }) : startSession),
    // endSession: (Config.localhost ? (() => { }) : endSession),
    // trackEvent: (Config.localhost ? (() => { }) : trackEvent)
};
